@let step3 = form();

<ng-container [formGroup]="step3">
  @if (!service.isEditing()) {
    <div class="form-row">
      @let accessGroups = accessGroups$ | async;
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Standard adgangsgrupper</mat-label>
        <mat-select
          [formControl]="step3.controls.selectedDefaultAccessGroups"
          multiple
          [compareWith]="compareObjects"
          okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ step3.controls.selectedDefaultAccessGroups.value[0]?.name || '' }}
            @if (step3.controls.selectedDefaultAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ step3.controls.selectedDefaultAccessGroups.value.length - 1 }}
                {{ step3.controls.selectedDefaultAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        @if (step3.controls.selectedDefaultAccessGroups.value.length) {
          <button
            matSuffix
            class="clear-input-field-button"
            type="button"
            (click)="step3.controls.selectedDefaultAccessGroups.setValue([]); $event.stopPropagation()"
            aria-label="Ryd indhold i feltet">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
          </button>
        }
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  }
  @if (service.isEditing() && pricePolicyChangeRequired()) {
    <div class="form-row">
      <ok-feedback-info>
        @if (netAreaRemoved()) {
          Den nye adresse har ikke et gyldigt netområde, så dynamiske prispolitikker kan ikke anvendes. Der skal derfor vælges en ny
          prispolitik.
        } @else {
          Ved ændring af OK-målerindstillingen skal der vælges en ny prispolitik.
        }
        <br /><br />
        Den valgte prispolitik tildeles alle ladepunkter på lokationen og bliver standard for nye ladepunkter.
      </ok-feedback-info>
    </div>
    @if (okPowerMeterChangedFromYes()) {
      <div class="form-row">
        <ok-feedback-info>
          Prisreguleringer af typen rabat er kun tilladt, når OK-måler er sat til Ja. Eventuelle ugyldige prisreguleringer vil derfor blive
          fjernet.
        </ok-feedback-info>
      </div>
    }
  }
  <div class="form-row">
    <adm-adm-price-policy-typeahead
      label="Standard prispolitik"
      [initialPricePolicyId]="step3.controls.pricePolicyId.value?.toString() ?? null"
      [organizationId]="organizationId()"
      [includeGlobal]="true"
      [alwaysIncludeDynamic]="canHaveDynamicPricePolicy()"
      [required]="true"
      [validationControl]="step3.controls.pricePolicyId"
      [type]="pricePolicyTypeByOkMeter()"
      [disabled]="service.isEditing() && !pricePolicyChangeRequired()"
      [resetTrigger]="pricePolicyResetTrigger()"
      (itemSelected)="onPricePolicySelected($event)" />
  </div>
  <div class="form-row">
    <adm-location-facilities-select [control]="step3.controls.facilities" />
  </div>
  <div class="form-row">
    <mat-slide-toggle formControlName="isLargeVehicleAccessible">
      Understøtter store køretøjer
      <br />
      <mat-hint class="tiny-text">Lastbil, lastbil med trailer, bus og traktor</mat-hint>
    </mat-slide-toggle>
  </div>
</ng-container>
